/** Leaflet divIcon HTML for TripReplayMap. The car artwork faces north; it's rotated via [data-rot]. */
import { GREEN } from './tripReplayData';

function carSvg(c) {
  return `<svg viewBox="0 0 24 44" width="24" height="44" style="display:block">
<rect x="1" y="13" width="2.6" height="3.2" rx="1" fill="${c}" stroke="#0c1014" stroke-width="1"/>
<rect x="20.4" y="13" width="2.6" height="3.2" rx="1" fill="${c}" stroke="#0c1014" stroke-width="1"/>
<rect x="3" y="2" width="18" height="40" rx="7" fill="${c}" stroke="#0c1014" stroke-width="1.5"/>
<path d="M6 12.6 Q12 9.4 18 12.6 L17 17.6 H7 Z" fill="#0c1014" opacity=".82"/>
<rect x="7" y="18.6" width="10" height="11" rx="2.5" fill="#fff" opacity=".24"/>
<path d="M7 31 H17 L18 35.2 Q12 37.2 6 35.2 Z" fill="#0c1014" opacity=".72"/>
<rect x="5" y="3.2" width="4" height="2" rx="1" fill="#fffbe0"/><rect x="15" y="3.2" width="4" height="2" rx="1" fill="#fffbe0"/>
<rect x="5" y="39.2" width="4" height="1.6" rx=".8" fill="#ff3b41"/><rect x="15" y="39.2" width="4" height="1.6" rx=".8" fill="#ff3b41"/></svg>`;
}
const ARROW = '<svg data-rot viewBox="0 0 24 24" width="15" height="15" style="display:block"><path d="M12 2 21 21l-9-5-9 5z" fill="#07150f"/></svg>';
const label = (plate) => `<div class="ltr-vlabel">${plate} · <span data-spd>0</span> km/h</div>`;

export function vehicleHtml(style, c, moving, plate) {
  const pulse = moving ? `<div class="ltr-pulse" style="background:${c}"></div>` : '';
  if (style === 'puck') {
    return `<div class="ltr-veh">${pulse}<div class="ltr-puck" style="background:${c};box-shadow:0 0 14px ${c}99">${ARROW}</div>${label(plate)}</div>`;
  }
  if (style === 'plate') {
    return `<div class="ltr-veh"><div class="ltr-platepill" style="border-color:${c};box-shadow:0 0 16px ${c}66,0 8px 18px -8px #000">
<span class="ltr-platedot" style="background:${c}">${ARROW.replace('width="15" height="15"', 'width="11" height="11"')}</span>
<span>${plate}</span><span style="color:${c}"><span data-spd>0</span> km/h</span></div></div>`;
  }
  return `<div class="ltr-veh">${pulse}<div class="ltr-halo" style="background:${c}"></div>
<div data-rot class="ltr-car">${carSvg(c)}</div>${label(plate)}</div>`;
}

export const START_HTML = '<div class="ltr-start"><i></i></div>';
export const END_HTML = `<svg viewBox="0 0 30 38" width="30" height="38" class="ltr-end"><path d="M15 2C8.4 2 3 7.4 3 14c0 8.8 12 22 12 22s12-13.2 12-22C27 7.4 21.6 2 15 2z" fill="${GREEN}" stroke="#eafff6" stroke-width="2"/><path d="M11 9v12M11 9h8l-2 3 2 3h-8" fill="none" stroke="#07150f" stroke-width="2" stroke-linejoin="round"/></svg>`;
export const stopHtml = (text) => `<div class="ltr-stop"><span>P</span>${text}</div>`;
const ICONS = {
  person: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="#07150f" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/>',
  car: '<path d="M5 11l1.6-4.4A2 2 0 0 1 8.5 5h7a2 2 0 0 1 1.9 1.6L19 11h1v6h-2v2h-3v-2H9v2H6v-2H4v-6z"/>',
  pin: '<path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/>',
  arrow: '<path d="M4 11h11.2l-4.6-4.6L12 5l7 7-7 7-1.4-1.4 4.6-4.6H4z"/>',
  cross: '<path d="M6 6l12 12M18 6 6 18" fill="none" stroke="#07150f" stroke-width="3.2" stroke-linecap="round"/>',
};
const esc = (v) => String(v || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

/** Numbered trip-status pin: coloured badge (number + icon) with a label pill — see .ltr-spin in the CSS. */
export function statusPinHtml(ev) {
  return `<div class="ltr-spin" style="--c:${ev.color}" title="${esc(ev.label)} · ${ev.time}">
<span class="ltr-spin-badge"><svg viewBox="0 0 24 24" width="11" height="11" fill="#07150f">${ICONS[ev.icon] || ICONS.pin}</svg><b>${ev.n}</b></span>
<span class="ltr-spin-label">${esc(ev.label)} <i>${ev.time}</i></span></div>`;
}
